import {
    Directive,
    TemplateRef,
    ViewContainerRef,
    Input,
    OnInit,
  } from '@angular/core';
import { SsoAuthService } from '../services/sso-auth.service';
  
  @Directive({
    selector: '[appHasRole]',
  })
  export class HasRoleDirective implements OnInit {
    constructor(
      private templateRef: TemplateRef<any>,
      private viewContainer: ViewContainerRef,
      private ssoAuthService: SsoAuthService
    ) {}
  
    roles: string[] = [];
  
    @Input() set appHasRole(roles: string[]) {
      this.roles = roles;
    }
  
    ngOnInit() {
      this.ssoAuthService.currentRpUser$.subscribe((rpUser) => {
        
        if (rpUser &&
          rpUser.currentRole &&
          this.roles.includes(rpUser.currentRole.name)) {

          this.viewContainer.clear();
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
      })
    }
  }
  